/**
 * PollMedia - Renderiza enquetes em mensagens do chat.
 * 
 * Princípios aplicados:
 * - Single Responsibility: Apenas renderiza enquetes
 * - Tokens semânticos: Usa classes do design system
 */
import React, { useMemo } from 'react';
import { safeParse } from './types.js';
import { MediaFallback } from './MediaFallback.js';

interface PollMediaProps {
    content?: string;
}

export const PollMedia: React.FC<PollMediaProps> = ({ content }) => {
    const data = useMemo(() => safeParse(content), [content]);

    if (!data) return <MediaFallback type="poll" fallbackLabel="Enquete inválida" />;

    return (
        <div className="bg-card rounded-lg border border-border overflow-hidden m-1 w-70 min-w-0 max-w-[calc(100%-0.5rem)]">
            <div className="p-3 bg-surface-subtle border-b border-subtle">
                <h4 className="font-semibold text-sm text-default">{data.name}</h4>
                <p className="text-xs text-muted mt-1">Selecione {data.selectableOptionsCount > 1 ? `até ${data.selectableOptionsCount} opções` : 'uma opção'}</p>
            </div>
            <div className="p-2 space-y-2">
                {data.options?.map((opt: string, idx: number) => (
                    <div key={idx} className="flex items-center gap-3 p-2 rounded hover:bg-surface-subtle cursor-pointer border border-transparent hover:border-subtle transition-all">
                        <div className="w-4 h-4 rounded-full border border-gray-400"></div>
                        <span className="text-sm text-secondary">{opt}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
